import { useStore } from '@roc/client-portal-shared/hooks';
import { getLenderDetailsRoutes } from '@roc/client-portal-shared/modules/lenderDetails';
import { getLoanRoutes, getPlatformLoanRoutes } from '../routes';
import { getLoanRoutesConfig, getPlatformLoanRoutesConfig } from '@roc/feature-loans-routes-config';
import { getWhatsNewRoutes, getWhatsNewRoutesConfig } from '@roc/feature-whats-new';
import { getLenderProfileRoutes, getLenderProfileRoutesConfig } from '../modules/lenderProfile/routes/lenderProfileRoutes';
import { useHistory } from 'react-router';
import {
  getProspectPropertiesRoutes,
  getProspectPropertiesRoutesConfig,
} from '@roc/feature-prospect-properties';
import {
  getBridgeProfitAndDscrCalculatorRoutes,
  getBridgeProfitAndDscrCalculatorRoutesConfig,
} from '@roc/feature-bridge-profit-and-dscr-calculator';
import { useAppsRoutes } from '@roc/feature-apps-contentful';
import { useQuoteGeneratorRoutes } from '@roc/feature-quote-generator'
import { getBackOfficeDashboardRoutes, getBackOfficeDashboardRoutesConfig } from '../modules/backOfficeDashboard/routes/backOfficeRoutes';
import { getCalendlyRoutes, getCalendlyRoutesConfig } from '../modules/calendly/calendlyRoutes';

export const useRoutes = () => {
  const { globalStore } = useStore();
  const { routeBasePath, routeBaseUrl } = globalStore;
  const { push } = useHistory();
  const lenderProfileRoutesConfig = getLenderProfileRoutesConfig(routeBasePath, routeBaseUrl);

  const {
    appsRoutes: appsRoutes,
    appsRoutesConfig: appsRoutesConfig
  } = useAppsRoutes();

  const {
    quoteGeneratorRoutes,
    quoteGeneratorRoutesConfig
  } = useQuoteGeneratorRoutes();


  return {
    appsRoutes,
    appsRoutesConfig,
    lenderDetailsRoutes: getLenderDetailsRoutes(
      routeBasePath,
      routeBaseUrl,
      () => push(lenderProfileRoutesConfig.lenderProfileDocuments.url)
    ),
    quoteGeneratorRoutes,
    quoteGeneratorRoutesConfig,
    loanRoutes: getLoanRoutes(routeBasePath, routeBaseUrl),
    loanRoutesConfig: getLoanRoutesConfig(routeBasePath, routeBaseUrl),
    platformLoanRoutes: getPlatformLoanRoutes(routeBasePath, routeBaseUrl),
    platformLoanRoutesConfig: getPlatformLoanRoutesConfig(routeBasePath, routeBaseUrl),
    whatsNewRoutes: getWhatsNewRoutes(routeBasePath, routeBaseUrl),
    whatsNewRoutesConfig: getWhatsNewRoutesConfig(routeBasePath, routeBaseUrl),
    lenderProfileRoutes: getLenderProfileRoutes(routeBasePath, routeBaseUrl),
    lenderProfileRoutesConfig,
    prospectPropertiesRoutes: getProspectPropertiesRoutes(
      routeBasePath,
      routeBaseUrl
    ),
    prospectPropertiesRoutesConfig: getProspectPropertiesRoutesConfig(
      routeBasePath,
      routeBaseUrl
    ),
    bridgeProfitAndDscrCalculatorRoutes: getBridgeProfitAndDscrCalculatorRoutes(
      routeBasePath,
      routeBaseUrl
    ),
    bridgeProfitAndDscrCalculatorRoutesConfig: getBridgeProfitAndDscrCalculatorRoutesConfig(
      routeBasePath,
      routeBaseUrl
    ),
    backOfficeRoutes: getBackOfficeDashboardRoutes(routeBasePath, routeBaseUrl),
    backOfficeRoutesConfig: getBackOfficeDashboardRoutesConfig(routeBasePath, routeBaseUrl),
    calendlyRoutes: getCalendlyRoutes(routeBasePath, routeBaseUrl),
    calendlyRoutesConfig: getCalendlyRoutesConfig(routeBasePath, routeBaseUrl),
  };
};
